import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectSideNavToggle } from "../../redux/side-menu/side-menu.selector";
import "./footer.styles.scss";

const Footer = (props) => {
 
 const getCurrentYear = () => {
    return new Date().getFullYear()
  }

  return (
    <Navbar
      bg="dark"
      variant="dark"
      className={"color-footer " + (props.sideNavToggle ? "active-footer" : "")}
    >
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="mr-auto footer-mobile-view">
          <Nav.Item className="footer-header-title">Callation Pty Limited {getCurrentYear()}</Nav.Item>
          <Nav.Link className="footer-header-links" target="_blank" href="https://www.callation.com/callation-tos.pdf">
            Terms of Service
          </Nav.Link>
          <Nav.Link className="footer-header-links" target="_blank" href="https://www.callation.com/callation-privacy.pdf">
            Privacy Policy
          </Nav.Link>
          <Nav.Link className="footer-header-links" target="_blank" href="https://support.callation.com/">Contact Us</Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

// mapStateToProps provides us the required state stored in the redux store
const mapStateToProps = createStructuredSelector({
  sideNavToggle: selectSideNavToggle,
});

export default connect(mapStateToProps)(Footer);
